// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import {Dictionary} from '../../../shared/models/dictionary.model';
import {IBaseType} from '../../../shared/enums/ibase-type.enum';

export interface ILandcategoryType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class LandcategoryType implements ILandcategoryType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Tribal LandcategoryType
	**/
    get Tribal(): ILandcategoryType {
        return this.FromId(1);
    }
    /**
		Returns Private LandcategoryType
	**/
    get Private(): ILandcategoryType {
        return this.FromId(2);
    }
    /**
		Returns Local Or State Parks LandcategoryType
	**/
    get Localorstateparks(): ILandcategoryType {
        return this.FromId(3);
    }
    /**
		Returns Bureau of Land Mgmt  LandcategoryType
	**/
    get Bureauoflandmgmt(): ILandcategoryType {
        return this.FromId(104);
    }
    /**
		Returns County  LandcategoryType
	**/
    get County(): ILandcategoryType {
        return this.FromId(105);
    }
    /**
		Returns USFWS LandcategoryType
	**/
    get Usfws(): ILandcategoryType {
        return this.FromId(106);
    }
    /**
		Returns NPS LandcategoryType
	**/
    get Nps(): ILandcategoryType {
        return this.FromId(107);
    }
    /**
		Returns State Trust Land LandcategoryType
	**/
    get Statetrustland(): ILandcategoryType {
        return this.FromId(108);
    }
    /**
		Returns USFS LandcategoryType
	**/
    get Usfs(): ILandcategoryType {
        return this.FromId(109);
    }
    /**
		Returns Military  LandcategoryType
	**/
    get Military(): ILandcategoryType {
        return this.FromId(110);
    }
    /**
		Returns Other LandcategoryType
	**/
    get Other(): ILandcategoryType {
        return this.FromId(111);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Tribal', displayValue: 'Tribal', description: 'Tribal ', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: 'Private', displayValue: 'Private', description: 'Private', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, value: 'LocalorStateParks', displayValue: 'Local or State Park', description: 'Local Or State Parks', sortOrder: 3, active: true });
        this._dictionary.add('104', { id: 104, value: 'BureauofLandMgmt', displayValue: 'Bureau of Land Management', description: 'Bureau of Land Management', sortOrder: 4, active: true });
        this._dictionary.add('105', { id: 105, value: 'County', displayValue: 'County ', description: 'County ', sortOrder: 5, active: true });
        this._dictionary.add('106', { id: 106, value: 'USFWS', displayValue: 'U.S. Fish and Wildlife', description: 'U.S. Fish and Wildlife', sortOrder: 6, active: true });
        this._dictionary.add('107', { id: 107, value: 'NPS', displayValue: 'National Park Service', description: 'National Park Service', sortOrder: 7, active: true });
        this._dictionary.add('108', { id: 108, value: 'StateTrustLand', displayValue: 'State Trust Land', description: 'State Trust Land', sortOrder: 8, active: true });
        this._dictionary.add('109', { id: 109, value: 'USFS', displayValue: 'U.S. Forest Service', description: 'USFS', sortOrder: 9, active: true });
        this._dictionary.add('110', { id: 110, value: 'Military', displayValue: 'Military ', description: 'Military ', sortOrder: 10, active: true });
        this._dictionary.add('111', { id: 111, value: 'Other', displayValue: 'Other', description: 'Other', sortOrder: 11, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ILandcategoryType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ILandcategoryType {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ILandcategoryType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ILandcategoryType[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): ILandcategoryType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
